import { Component, OnInit } from '@angular/core';
import { MojaFirmaClient, SubscriptionPackage, VrstaStranke } from '@kodit/core/data-api';
import { AuthService, SefService } from '@kodit/core/services';
import {Router} from "@angular/router";

@Component({
  selector: 'kodit-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  /** Props */
  vrstaStrankeDobavljac = VrstaStranke.DOBAVLJAC;
  vrstaStrankeKupac = VrstaStranke.KUPAC;
  shouldDisplayPromet = true;
  shouldDisplayTopNStranki = true;

  constructor(
    private _authService: AuthService,
    private _router : Router,
  ) {}

  ngOnInit() {
    this.shouldDisplayPromet = this._authService.hasPackage(
      [
        SubscriptionPackage[SubscriptionPackage.EFAKTURE],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
        SubscriptionPackage[SubscriptionPackage.BESPLATNO]
      ]
    );
    this.shouldDisplayTopNStranki =
      this.shouldDisplayPromet &&
      this._authService.hasPackage(
        SubscriptionPackage[SubscriptionPackage.EFAKTURE_API]
      );

    if (!this.shouldDisplayPromet && !this.shouldDisplayTopNStranki) {
      this._shouldRouteToSelectedPackagePage();
    }
  }

  private _shouldRouteToSelectedPackagePage(){
    if(this._authService.hasPackage(SubscriptionPackage[SubscriptionPackage.ARHIVA])){
      this._router.navigate(['/kompanija', 'arhivska-knjiga']).then();
    }

    if(this._authService.hasPackage(SubscriptionPackage[SubscriptionPackage.EOTPREMNICE])){
      this._router.navigate(['/eotpremnice', 'slanje-robe']).then();
    }

    if(this._authService.hasPackage(SubscriptionPackage[SubscriptionPackage.MALOPRODAJA])){
      this._router.navigate(['/maloprodaja', 'fiskalni']).then()
    }

    return;
  }
}
